<template>
  <div class="relative">
    <iframe v-if="getType=='video' && active" class="fill" :src='content'/>
    <video v-if="getType=='video_imgur' && active" class="fill" autoplay="autoplay" muted=true loop="loop">
      <source class="fill" :src='content'/>
    </video>
    <img v-if="getType=='img'" :class="{invisible: !active}" class="fill" :src='content'/>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    active: Boolean
  },
  computed:{
    getType(){
      if(this.content.includes('youtu'))
        return 'video'
      if(this.content.includes('.mp4'))
        return 'video_imgur'
      return 'img'
    }
  },
}
</script>

<style scoped>

.fill:not(.invisible) {
  animation: show 0.1s ease-out;
  animation-fill-mode: forwards;
  display: block;
}


.fill.invisible{
  opacity: 0.0;
  display: none;
}



@keyframes show {
  0%{
    opacity: 0.5;
  };
  100%{
    opacity: 1.0;
  }
}

.relative{
  pointer-events: none;
}

.bg{
  background: black;
  z-index: -1;
}

.fill{
  pointer-events: all;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}



</style>
